<template>
    <div @click="activeSelect = false">
        <div class="fullscreen-page-title">
            {{ tokens.fullScreen.withdrawal.toUpperCase() }}
        </div>
        <div class="row fs flex-start" :class="{hide: !user.enable_withdrawal}">
            <div class="form-row fs">
                <div class="form-title">
                    {{ tokens.fullScreenWithdrawal.requestNewWithdrawal }}
                </div>
            </div>
            <div class="col fs">

                <div class="form-row fs">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.amount }}</label>
                    <input v-model="amount" class="form-control fs"/>
                    <!--                    <div class="tip">-->
                    <!--                        <span>{{ tokens.fullScreenWithdrawal.currentBalance }} {{ currencySign(activeAccount.currency)+activeAccount.balance.toFixed(activeAccount.precision) }}</span>-->
                    <!--                        <span class="all" v-on:click="amount = activeAccount.balance > 0 ? activeAccount.balance : 0">{{ tokens.fullScreenWithdrawal.withdrawAll }}</span>-->
                    <!--                    </div>-->
                </div>
                <div class="form-row fs">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.withdrawalDetails }}</label>
                    <select class="form-control fs" v-model="method" :class="{activeSelect: activeSelect}"
                            @click.stop="activeSelect = !activeSelect">
                        <option v-for="(value, key) in withdrawalOptions" :key="key" :value="key">
                            {{ withdrawalOption(value) }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="form-row fs">
                <div class="form-title">
                    {{ tokens.fullScreenWithdrawal.withdrawalDetails.toUpperCase() }}
                </div>
            </div>
            <div class="col fs">
                <div class="form-row fs" v-bind:class="{hide: method !== 'btc' && method !== 'eth' && method !== 'usdt' && method !== 'matic' && method !== 'usdt_erc20'}">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.address }}</label>
                    <input 
                        type="text" 
                        class="form-control fs" 
                        autocomplete="off"
                        v-model="methods.btc.wallet" 
                        @focus="togglePrevWalletDropdown('open')"
                        @blur="togglePrevWalletDropdown('close')"
                    >
                    <ul v-if="prevWalletDropdownState && prevWithdrawals" class="prev-wallet__dropdown">
                        <li @click.stop="choosePrevWallet(prevWithdrawals)">{{ prevWithdrawals }}</li>
                    </ul>
                </div>
                <div v-if="bankWithdrawalFields.includes('account')" class="form-row fs" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.bankAccount }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.account">
                </div>
                <div v-if="bankWithdrawalFields.includes('holder')" class="form-row fs" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.bankHolder }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.holder">
                </div>
                <div v-if="bankWithdrawalFields.includes('iban')" class="form-row" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ brand === 'rileyfinance' ? 'BSB' : tokens.fullScreenWithdrawal.bankIban }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.iban">
                </div>
                <div class="form-row fs" v-if="bankWithdrawalFields.includes('swift') && brand !== 'rileyfinance'" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.bankSwift }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.swift">
                </div>
                <div v-if="bankWithdrawalFields.includes('sortCode')" class="form-row fs" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.sortCode }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.sortCode"   v-mask="'##-##-##'">
                </div>
                <div v-if="bankWithdrawalFields.includes('ifscCode')" class="form-row fs" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.ifscCode }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.ifscCode">
                </div>
                <!-- BSB is Australia's domestic routing number and is meaningless anywhere else, so
                     it follows the CLIENT's country as well as the brand's field list. Brands built
                     for Australia (blackridge, oakridgeau, atgaustralia, pacfund, pjmarkets and the
                     rest) already list bankCode and keep showing it to everyone, which is why the
                     brand condition stays: dropping it would take the field away from their
                     non-Australian clients, who would then have no IBAN or SWIFT box either. -->
                <div v-if="bankWithdrawalFields.includes('bankCode') || isAustralianClient" class="form-row fs" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.bankCode }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.bankCode">
                </div>
                <div v-if="bankWithdrawalFields.includes('bankName')" class="form-row fs" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.bankName }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.bankName">
                </div>
                <div v-if="bankWithdrawalFields.includes('bankBranch')" class="form-row fs" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.bankBranch }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.bankBranch">
                </div>
                <div v-if="bankWithdrawalFields.includes('country')" class="form-row fs" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ 'Country' }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.country">
                </div>
                <div v-if="bankWithdrawalFields.includes('city')" class="form-row fs" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ 'City' }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.city">
                </div>
                <div v-if="bankWithdrawalFields.includes('street')" class="form-row fs" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ 'Street' }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.street">
                </div>
                <div v-if="bankWithdrawalFields.includes('postcode')" class="form-row fs" v-bind:class="{hide: method !== 'bank'}">
                    <label class="fs">{{ 'Postcode' }}</label>
                    <input type="text" class="form-control fs" v-model="methods.bank.postcode">
                </div>
                <div class="form-row fs" v-bind:class="{hide: method !== 'interact'}">
                    <label class="fs">{{ 'Name' }}</label>
                    <input type="text" class="form-control fs" v-model="methods.interact.name">
                </div>
                <div class="form-row fs" v-bind:class="{hide: method !== 'interact'}">
                    <label class="fs">{{ 'Email' }}</label>
                    <input type="text" class="form-control fs" v-model="methods.interact.email">
                </div>
                <div v-if="['thundrapro','maplestouch'].includes(brand)" class="form-row fs" v-bind:class="{hide: method !== 'etransfer'}">
                    <label class="fs">{{ 'Name' }}</label>
                    <input type="text" class="form-control fs" v-model="methods.etransfer.name">
                </div>
                <div class="form-row fs" v-bind:class="{hide: method !== 'etransfer'}">
                    <label class="fs">{{ 'Email' }}</label>
                    <input type="text" class="form-control fs" v-model="methods.etransfer.email">
                </div>
                <div v-if="bankWithdrawalFields.includes('phone_number') || alwaysShowPhoneField" class="form-row fs" v-bind:class="{hide: method !== 'bank' && !alwaysShowPhoneField}">
                    <label class="fs">{{ 'Phone Number' }}</label>
                    <input 
                        class="form-control fs" 
                        v-model="methods.bank.phone_number.value" 
                        v-mask="maskedPhone"
                        @input="handlePhoneInput"
                        :disabled="!user.country"
                        @focus="methods.bank.phone_number.valid = true"
                        :class="{ 'invalid-input': !methods.bank.phone_number.valid }"
                    />
                </div>
                <div class="form-row fs" v-bind:class="{hide: method !== 'card'}">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.cardNumber }}</label>
                    <input type="text" class="form-control fs" v-model="methods.card.number">
                </div>
                <div class="form-row fs" v-bind:class="{hide: method !== 'card'}">
                    <label class="fs">{{ tokens.fullScreenWithdrawal.cardHolder }}</label>
                    <input type="text" class="form-control fs" v-model="methods.card.holder">
                </div>
            </div>
        </div>
        <div class="form-row pad fs-bottom" :class="{hide: !user.enable_withdrawal}">
            <button class="fs-normal" v-on:click="requestWithdrawal">{{
                    tokens.fullScreenWithdrawal.requestWithdrawal
                }}
            </button>
            <button
                v-if="withdrawalPolicyModal" 
                class="fs-normal withdrawal-policy-button" 
                v-on:click="openWithdrawalPolicyModal"
            >
                    {{ 'Withdrawal Policy' }}
            </button>
        </div>
        <div class="form-row fs">
            <div class="form-title">
                {{ tokens.fullScreenWithdrawal.withdrawalRequests }}
            </div>
        </div>
        <div class="table-cont">
            <table class="cabinet fs">
                <thead>
                <tr>
                    <th class="nomobile fs" v-if="!hideWithdrawalTime">{{ tokens.fullScreenWithdrawal.time.toUpperCase() }}</th>
                    <th class="fs">{{ tokens.fullScreenWithdrawal.amount.toUpperCase() }}</th>
                    <th class="fs">{{ tokens.fullScreenWithdrawal.currency.toUpperCase() }}</th>
                    <th class="fs" v-if="!disableInfoTable">{{ tokens.fullScreenWithdrawal.info.toUpperCase() }}</th>
                    <th class="fs">{{ tokens.fullScreenWithdrawal.status.toUpperCase() }}</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="withdrawal in withdrawals.slice(0,10)"
                    :key="withdrawal.id"
                >
                    <td class="nomobile" v-if="!hideWithdrawalTime">{{ brand === 'uccglobal' ? new Date(withdrawal.time_created * 1000).toLocaleString(undefined, { year: 'numeric' }) : new Date(withdrawal.time_created * 1000).toLocaleString() }}</td>
                    <td class="fs">{{
                            currencySign(withdrawal.currency) + Math.abs(withdrawal.amount).toFixed(activeAccount.precision)
                        }}
                    </td>
                    <td colspan="fs">{{ withdrawal.currency }}</td>
                    <td class="fs" v-if="!disableInfoTable">{{ withdrawal.comment }}</td>
                    <td class="fs">
                        {{ tokens.statuses[withdrawal.status] }}
                        <i v-if="withdrawal.status === 0 && !hideWithdrawal" @click="confirmCancelWithdrawal(withdrawal.id)"
                           class="material-icons cancel-withdrawal" title="Cancel withdrawal request">cancel</i>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {currencySign, fullCountriesList} from "@/common/helpers";
import {WITHDRAWAL_REQUEST} from "@/store/actions.type";
import {NOTIFICATION_ERROR, MODAL, MODAL_WITHDRAWAL_CANCEL} from "@/store/mutations.type";
import {
    BRAND,
    CLOSE_WITHDRAWAL,
    DISABLE_INFO_TABLE,
    MINIMUM_WITHDRAWAL,
    WITHDRAWAL_OPTIONS,
    DEFAULT_WITHDRAWAL_CURRENCY,
    BANK_WITHDRAWAL_FIELDS,
    REQUIRED_WITHDRAWAL, 
    HIDE_WITHDRAWAL_TIME,
    WITHDRAWAL_POLICY_MODAL
} from "@/common/config";
import {mask} from 'vue-the-mask'

export default {
    name: "Withdrawal",
    directives: {mask},
    data() {
        return {
            amount: '',
            hideWithdrawal: CLOSE_WITHDRAWAL,
            method: WITHDRAWAL_OPTIONS.bank ? 'bank' : 'btc',
            disableInfoTable : DISABLE_INFO_TABLE,
            bankWithdrawalFields: BANK_WITHDRAWAL_FIELDS,
            activeSelect: false,
            hideWithdrawalTime: HIDE_WITHDRAWAL_TIME,
            methods: {
                btc: {
                    wallet: ''
                },
                bank: {
                    account: '',
                    holder: '',
                    iban: '',
                    swift: '',
                    sortCode: '',
                    ifscCode: '',
                    bankCode: '',
                    bankName: '',
                    bankBranch: '',
                    country: '',
                    city: '',
                    street: '',
                    postcode: '',
                    phone_number: {
                        value: '',
                        valid: true
                    },
                },
                card: {
                    number: '',
                    holder: ''
                },
                interact:{
                    name: '',
                    email: '',
                },
                etransfer:{
                    name: '',
                    email: '',
                },
            },
            maskedPhone: '',
            defaultWithdrawalCurrency: DEFAULT_WITHDRAWAL_CURRENCY,
            withdrawalOptions: WITHDRAWAL_OPTIONS,
            brand: BRAND,
            prevWalletDropdownState: false,
            withdrawalPolicyModal: WITHDRAWAL_POLICY_MODAL,
        }
    },
    methods: {
        confirmCancelWithdrawal(id) {
            this.$store.commit(MODAL_WITHDRAWAL_CANCEL, id)
            this.$store.commit(MODAL, {
                withdrawalCancel: true
            })
        },
        withdrawalOption(value){
          if (BRAND === "cryptossaylor") {
             switch (value) {
                 case 'bank': return 'Bank Transfer'
                 case 'card': return 'Credit Card'
                 default: return this.tokens.fullScreenWithdrawal[value]
             }
          }

          //crutch for novixgrade
          if (['novixgrade','nexbergag','crownexcapitalgroup','vertexcapitalgroup'].includes(this.brand)) {
             switch (value) {
                 case 'bank': return 'Wire Transfer'
                 case 'bitcoin': return 'BTC'
                 case 'ethereum': return 'ETH'
                 case 'usdt': return 'USDT TRC-20'
                 case 'matic': return 'Other'
                 default: return this.tokens.fullScreenWithdrawal[value]
             }
          }
          return this.tokens.fullScreenWithdrawal[value]
        },
        requestWithdrawal() {
            if (BRAND === "stbmarkets" && Object.keys(this.orders).length) {
                this.$store.commit(NOTIFICATION_ERROR, 'CLOSE_OPEN_ORDERS')
                return
            }

            let amount = String(this.amount)

            amount = amount.includes(',') ? amount.replace(/,/, '.') : amount
            amount = parseFloat(amount) || 0

            if (amount <= 0 || amount > this.activeAccount.balance) {
                this.$store.commit(NOTIFICATION_ERROR, 'The amount is incorrect')
                return
            }

            for(let n in this.withdrawals) {
                if (this.withdrawals[n].status === 0) {
                    this.$store.commit(NOTIFICATION_ERROR, 'LOCAL_ONE_PENDING_WITHDRAWAL')
                    return
                }
            }

            if (isNaN(parseFloat(amount)) || parseFloat(amount) < MINIMUM_WITHDRAWAL) {
                this.$store.commit(NOTIFICATION_ERROR, 'Minimum withdrawal amount is $' + MINIMUM_WITHDRAWAL)
                return
            }

            if (this.method === 'btc') {
                if (amount * this.symbols['BTCUSD'].quote.bid < MINIMUM_WITHDRAWAL) {
                    this.$store.commit(NOTIFICATION_ERROR, 'Minimum withdrawal amount is $' + MINIMUM_WITHDRAWAL)
                    return
                }
            } else if (this.method === 'bank' || this.method === 'card') {
                if (amount < MINIMUM_WITHDRAWAL) {
                    this.$store.commit(NOTIFICATION_ERROR, 'Minimum withdrawal amount is $' + MINIMUM_WITHDRAWAL)
                    return
                }
            }

            if(this.method === 'bank' && this.bankWithdrawalFields.includes('sortCode')){
               if(this.methods.bank.sortCode.length !== 8){
                this.$store.commit(NOTIFICATION_ERROR, 'Please complete Sort Code field')
                return
               }
            }

            if(REQUIRED_WITHDRAWAL){
                if(this.method === 'card'){
                    if(!this.methods.card.number.trim() || !this.methods.card.holder.trim()){
                        this.$store.commit(NOTIFICATION_ERROR, 'Please fill in all fields' )
                        return
                    }
                }else if(this.method === 'bank'){
                    for (let i = 0; i < BANK_WITHDRAWAL_FIELDS.length; i++){
                        if(!this.methods.bank[BANK_WITHDRAWAL_FIELDS[i]].trim()){
                        this.$store.commit(NOTIFICATION_ERROR, 'Please fill in all fields' )
                            return
                        }
                    }
                }else{
                    if(!this.methods.btc.wallet.trim()){
                        this.$store.commit(NOTIFICATION_ERROR, 'Please fill in all fields' )
                        return
                    }
                }
            }

            if(this.bankWithdrawalFields.includes('phone_number') && (this.method === 'bank' || this.alwaysShowPhoneField)){
                let phoneNumber = this.methods.bank.phone_number.value;
   
                let isPhoneValid = phoneNumber && phoneNumber.startsWith(this.userCountryWithCode?.code) && (phoneNumber.length === this.userCountryWithCode?.mask.length || (phoneNumber.length >= this.userCountryWithCode?.min && phoneNumber.length <= this.userCountryWithCode?.max))

                this.methods.bank.phone_number.valid = isPhoneValid

                if(!isPhoneValid){
                    this.$store.commit(NOTIFICATION_ERROR, this.userCountryWithCode?.mask ? 'Please enter a valid phone number' : 'Please select your country first' )
                    return
                }
            }else{
                this.methods.bank.phone_number.value = ''
            }

            let details = ''
            switch (this.method) {
                case 'btc':
                    details = `BTC: ${this.methods.btc.wallet}`
                    break
                case 'bank':
                    details =
                        `Account: ${this.methods.bank.account}\nAccount holder: ${this.methods.bank.holder}${this.methods.bank.iban ? `\nIBAN: ` + this.methods.bank.iban : ''}${this.methods.bank.swift ? '\nSWIFT: ' + this.methods.bank.swift : ''}${this.methods.bank.sortCode ? '\nSort Code: ' + this.methods.bank.sortCode : ''}${this.methods.bank.ifscCode ? '\nIFSC Code: ' + this.methods.bank.ifscCode : ''}${this.methods.bank.bankCode ? '\nBank Code (BSB): ' + this.methods.bank.bankCode : ''}${this.methods.bank.bankName ? '\nBank Name: ' + this.methods.bank.bankName : ''}${this.methods.bank.bankBranch ? '\nBank Branch: ' + this.methods.bank.bankBranch : ''}${this.methods.bank.country ? '\nCountry: ' + this.methods.bank.country : ''}${this.methods.bank.city ? '\nCity: ' + this.methods.bank.city : ''}${this.methods.bank.street ? '\nStreet: ' + this.methods.bank.street : ''}${this.methods.bank.postcode ? '\nPostcode: ' + this.methods.bank.postcode : ''}${this.methods.bank.phone_number.value ? '\nPhone number: ' + this.methods.bank.phone_number.value : ''}`
                    break
                case 'card':
                    details =
                        `Card: ${this.methods.card.number}\nCard holder: ${this.methods.card.holder}${this.methods.bank.phone_number.value ? '\nPhone number: ' + this.methods.bank.phone_number.value : ''}`
                    break
                case 'eth':
                    details = `ETH: ${this.methods.btc.wallet}${this.methods.bank.phone_number.value ? '\nPhone number: ' + this.methods.bank.phone_number.value : ''}`
                    break
                case 'usdt':
                    details = `USDT: ${this.methods.btc.wallet}${this.methods.bank.phone_number.value ? '\nPhone number: ' + this.methods.bank.phone_number.value : ''}`
                    break
                case 'usdt_erc20':
                    details = `USDT ERC-20: ${this.methods.btc.wallet}${this.methods.bank.phone_number.value ? '\nPhone number: ' + this.methods.bank.phone_number.value : ''}`
                    break
                case 'matic':
                    details = `MATIC: ${this.methods.btc.wallet}${this.methods.bank.phone_number.value ? '\nPhone number: ' + this.methods.bank.phone_number.value : ''}`
                    break
                case 'interact':
                    details = `Interact${this.methods.interact.name ? '\nName: ' + this.methods.interact.name : ''}${this.methods.interact.email ? '\nEmail: ' + this.methods.interact.email : ''}`
                    break
                case 'etransfer':
                    if(['thundrapro','maplestouch'].includes(this.brand)){
                        details = `Etransfer${this.methods.etransfer.name ? '\nName: ' + this.methods.etransfer.name : ''}${this.methods.etransfer.email ? '\nEmail: ' + this.methods.etransfer.email : ''}`
                    }else{
                        details = `Etransfer${this.methods.etransfer.email ? '\nEmail: ' + this.methods.etransfer.email : ''}`
                    }
                    break
            }

            this.$store.dispatch(WITHDRAWAL_REQUEST, {
                wallet: details,
                amount: amount,
                account_id: this.activeAccount.id,
                product: this.activeAccount.product,
                currency: this.defaultWithdrawalCurrency ? this.defaultWithdrawalCurrency.replaceAll('\'', '') :  this.activeAccount.currency
            })

            this.method = 'bank'
            this.methods.btc.wallet = ''
            this.methods.bank.account = ''
            this.methods.bank.holder = ''
            this.methods.bank.iban = ''
            this.methods.bank.swift = ''
            this.methods.bank.sortCode = ''
            this.methods.bank.ifscCode = ''
            this.methods.bank.bankCode = ''
            this.methods.bank.bankName = ''
            this.methods.bank.bankBranch = ''
            this.methods.bank.phone_number.value = this.userCountryWithCode?.code
            this.methods.bank.phone_number.valid = true
            this.methods.card.number = ''
            this.methods.card.holder = ''
            this.methods.card.holder = ''
            this.methods.interact.name = ''
            this.methods.interact.email = ''
            this.methods.etransfer.email = ''
            this.methods.etransfer.name = ''
            this.amount = ''
        },
        handlePhoneInput() {
            this.methods.bank.phone_number.value = this.methods.bank.phone_number.value.replace(/[^+\d-]/g, "")
        },
        togglePrevWalletDropdown(state=false) {
            setTimeout(() => {
                if(state === 'open') this.prevWalletDropdownState = true
                if(state === 'close') this.prevWalletDropdownState = false
                if(!state) this.prevWalletDropdownState = !this.prevWalletDropdownState
            }, 200);
        },
        choosePrevWallet(wallet) {
            this.methods.btc.wallet = wallet
        },
        openWithdrawalPolicyModal() {
            if(this.withdrawalPolicyModal) {
                this.$store.commit(MODAL, {
                    withdrawalPolicy: true
                })
            }
        },
        currencySign
    },
    computed: {
        ...mapGetters(['withdrawals', 'orders', 'activeAccount', 'realAccount', 'symbols', 'user', 'tokens','modalFullscreen']),
        balances() {
            let b = {
                balance: 0,
                orders: 0,
                profit: 0,
                credit: 0,
                margin: 0,
                // equity: 0,
                margin_level_apprx: 0,
                free_margin_apprx: 0,
                equity_apprx: 0
            }

            if (!this.activeAccount.id) {
                return b
            }

            b.balance = this.activeAccount.balance
            b.credit = this.activeAccount.credit

            let marginBySymbol = {}

            for(let n in this.activeAccount.orders) {
                let o = this.activeAccount.orders[n]

                o.easy_amount = o.easy_amount || o.margin

                b.orders += o.easy_amount

                if (marginBySymbol[o.symbol] === undefined) {
                    marginBySymbol[o.symbol] = 0
                }

                marginBySymbol[o.symbol] += o.type % 2 ? -o.margin : o.margin

                if (!this.symbols[o.symbol]) {
                    continue
                }

                b.profit += o.type < 2 ? (o.point * (o.type ? o.price_open - this.symbols[o.symbol].quote.ask : this.symbols[o.symbol].quote.bid - o.price_open) * Math.pow(10, this.symbols[o.symbol].precision) + o.swap + o.commission) : 0
            }

            for(let n in marginBySymbol) {
                b.margin += Math.abs(marginBySymbol[n])
            }

            b.equity = b.balance + b.credit + b.profit
            b.margin_level_apprx = this.activeAccount.balance + this.activeAccount.credit + b.profit !== 0 && b.margin ? (100 * (this.activeAccount.balance + this.activeAccount.credit + b.profit) / b.margin).toFixed(2) : ''
            b.free_margin_apprx = this.activeAccount.balance + this.activeAccount.credit + b.profit - b.margin
            b.equity_apprx =  b.equity

            return b
        },
        userCountryWithCode() {
            let userCountry = this.user?.country;
            if(userCountry === 'Russia'){
                userCountry = 'Russian Federation'
            }

            return Object.values(fullCountriesList()).find(country => country.name.toLowerCase() === (userCountry?.toLowerCase())) || {code: '', mask: ''}
        },
        isAustralianClient() {
            // Matched on the country NAME, not on userCountryWithCode.code: that `code` is the
            // phone prefix (+61) and the ISO code is only the key of fullCountriesList(), which
            // Object.values() throws away. `au` is accepted as well because nothing guarantees
            // every record stores the display name.
            const c = String(this.user?.country || '').trim().toLowerCase()
            return c === 'australia' || c === 'au'
        },
        alwaysShowPhoneField() {
            return ['novixgrade','nexbergag','crownexcapitalgroup' ,'vertexcapitalgroup'].includes(this.brand)
        },
        prevWithdrawals() {
            let cryptoWtdsWalletText = ['ETH:','BTC:','USDT:','USDT ERC-20:','MATIC:']
            let prevCryptoWithdrawal = this.withdrawals.find(wtd => {
                return cryptoWtdsWalletText.some(wallet => wtd.wallet.includes(wallet))
            })

            if(!prevCryptoWithdrawal) {
                return ''
            }else{
                return cryptoWtdsWalletText.reduce((acc, curr) => acc.replace(curr, ''), prevCryptoWithdrawal.wallet || '').trim()
            }
        }
    },
    watch:{
        modalFullscreen: {
            handler(val) {
                if (val.page === 'withdrawal' && this.bankWithdrawalFields.includes('phone_number')) {
                    this.$set(this, 'maskedPhone', '+' + (this.userCountryWithCode?.mask?.slice(0,-1) || 'XXX-XXXXXX'))
                    this.methods.bank.phone_number.value = this.userCountryWithCode.code;
                }
            },
            deep: true
        }
    }

}
</script>

<style scoped>
.row.fs {
    grid-template-columns: 1fr;
}

.col {
    flex: 1 1 40%
}

.col.fs {
    margin-bottom: .5vw;
}

input, select {
    width: 100%;
}

.tip {
    font-size: 1.1em;
    font-weight: 400;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    margin-top: 5px;
}

.all {
    margin-left: 20px;
    color: var(--white);
    border-bottom: 1px dashed var(--white);
    cursor: pointer;
    white-space: nowrap;
}

.pad {
    margin-bottom: 50px;
}

.cancel-withdrawal {
    vertical-align: middle;
    cursor: pointer;
}

.invalid-input {
    border: 1px solid var(--red);
}

.form-row:has(.withdrawal-policy-button){
    display: flex;
    flex-direction: row;
    gap: 12px;
}

.form-row.fs:has(.prev-wallet__dropdown){
    position: relative;
}

.prev-wallet__dropdown{
    position: absolute;
    bottom: -60%;
    left: 0;
    list-style: none;
    color: var(--white-to-black);
    font-size: 13px;
    padding: 4px;
    width: 100%;
    border: 0.1vw solid rgba(255, 255, 255, 0.3);
    background: var(--background-dark-mid);
    overflow-x: auto;
    li{
        padding: .4vw .625vw;
        width: 100%;
        min-width: max-content;
        cursor: pointer;
        &:hover{
            background: #1967d2;
        }
    }
}

@media (min-width: 1000px) {
    .fs-bottom {
        margin-bottom: 2vw;
    }

    .prev-wallet__dropdown{
        font-size: 1.1vw;
        padding: 0px;
    }
}

@media (max-width: 1000px) {
    .col.fs {
        margin-bottom: 20px;
    }
}

</style>
